<div class="container">
    <app-shell 
        style="width: 100%; height: 100%;"
        [disableDocuments]="true"
        #shellComponent    
    >
        <div class="customer-type stack">
            <div id="question" style="display: flex;">
                <h1>{{this.questionText}}</h1>
            </div>
            
            <div id="question-answer">
                <app-multi-answer-button-list 
                    [options]="customerTypeData"
                    cssClass="stack"
                    (outputParameter)="handleOutput($event)"
                ></app-multi-answer-button-list>

                <div *ngIf="this.othersSelected">
                    <ng-container [formGroup]="form">
                        <div class="signUpTextBoxs">
                            <app-kendo-textbox 
                                inputText="Others" 
                                formControlName="others" 
                                inputType="text"
                                [parentForm]="form"
                            ></app-kendo-textbox>

                            <div 
                                *ngIf=" this.form.get('others')?.invalid &&(this.form.get('others')?.dirty ||
                                    this.form.get('others')?.touched)"
                            >
                                <kendo-formerror 
                                    *ngIf="this.form.get('others')?.errors?.['required']"
                                >
                                    Enter a custom customer type or unselect Others
                                </kendo-formerror>
                            </div>
                        </div>
                    </ng-container>
                </div>
                <div class="button-wrapper">
                    <app-stateful-primary-button 
                        type="submit" 
                        [clickEvent]="this.submit.bind(this)" 
                        [text]="'Next'"
                        [pageUrl]="this.nextState['pageUrl']"
                        [stateId]="this.nextState['id']"
                        [colorCssClass]="'orange'"
                    ></app-stateful-primary-button>
                </div>
            </div>

            <div id="bottom-nav">
                <div id="back">
                    <app-stateful-secondary-button type="submit" [text]="'Back'"
                        [pageUrl]="this.backState['pageUrl']"
                        [stateId]="this.backState['id']"></app-stateful-secondary-button>
                </div>
                <div id="skip">
                    <app-stateful-secondary-button type="submit" [text]="'Skip'"
                        [pageUrl]="this.skipState['pageUrl']"
                        [stateId]="this.skipState['id']"></app-stateful-secondary-button>
                </div>
            </div>
        </div>
    </app-shell>
</div>